<template>
  <div>
    <iframe class="res-doc" :src="fullPath"></iframe>
  </div>
</template>

<script type="text/ecmascript-6">
  import mixins from './attachMixin'

  export default {
    mixins: [mixins],
    created () {
      this.initPage()
    },
    methods: {
      initPage () {
        var self = this
        // var demo = "https://docs.ulearning.cn/?i=16664&ssl=1&furl=https://leicloud.ulearning.cn/homework/web/0/1535013275382/ resource010441400b88ca24-242c-46d0-b529-e41de9f3caad.xls";
        var src = this.docsURL + "?time=1";
        var location = self.uFilePath;
        if (location.indexOf("https://") != -1) {
          src += "&ssl=1";
        }
        src += "&furl=" + encodeURIComponent(location);
        self.fullPath = src;
      }
    }
  }
</script>

<style scoped lang="scss">
  .res-doc{
    display: block;
    width: 100%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/common/components/uAttach/uDocAttach.vue